<template>
  <div class="vc-panel">
    <el-scrollbar class="vh-full">
      <div class="inrect">
        <!-- 欢迎 -->
        <div class="dvwel">
          <h1 class="wtitle">欢迎回来，{{ nickName }}!</h1>
          <div class="lbwsub">今天又是充满活力的一天，继续你的英语学习之旅吧！</div>
          <div class="laters" v-if="learnUnit != null">
            <div class="lblatelyw">
              <i class="fa fa-flag" style="color: #ff6000;"></i>
              <span class="mgl10">{{ learnUnit.bookName }}</span>
              <svg-icon class="splitd" svgname="ic_xiegan" :size="16" fill="var(--ek-text-color3)"></svg-icon>

              <span>{{ learnUnit.unitName }}</span>
              <svg-icon class="splitd" svgname="ic_xiegan" :size="16" fill="var(--ek-text-color3)"></svg-icon>
              <span class="">{{ learnUnit.orderSeqNo }}/{{ learnUnit.sentenceCount }}</span>
            </div>
            <div @click="continueLearn" class="bnt-learn focus-s">
              <SvgIcon svgname="ic_run" :size="16" fill="#ffffff"></SvgIcon>
              <span class="mgl5">继续学习</span>
            </div>
          </div>
        </div>
        <!--统计数据-->
        <div class="card-container">
          <div class="card-item">
            <div>
              <div class="card-item-title">今日学习时长</div>
              <div class="card-item-num">
                <span>{{todayMinute}}</span>
                <span class="lbunit">分钟</span>
              </div>
            </div>
            <span class="icon">📘</span>
          </div>
          <div class="card-item">
            <div>
              <div class="card-item-title">本周累计</div>
              <div class="card-item-num">
                <span>{{weekMinute}}</span>
                <span class="lbunit">分钟</span>
              </div>
            </div>
            <span class="icon" style="background: rgba(34, 197, 94, 0.12);">🎯</span>
          </div>
          <div class="card-item">
            <div>
              <div class="card-item-title">本周平均</div>
              <div class="card-item-num">
                <span>{{weekAvgMinute}}</span>
                <span class="lbunit">分钟</span>
              </div>
            </div>
            <span class="icon" style="background: rgba(22, 163, 74, 0.12);">✅</span>
          </div>
        </div>
        <!--图表数据，这里显示图表-->
        <LearnTimeChartView :listDate="listDate"></LearnTimeChartView>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import LearnTimeChartView from './views/LearnTimeChartView.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import localUser from '@/commom/local/LocalUser';
import httpClient from '@/commom/http/httpClient';
import localCache from '@/commom/local/LocalCache';

export default {
  name: 'UserHomePage',
  components: {
    LearnTimeChartView,
    SvgIcon
  },
  data() {
    return {
      nickName: "--",
      ///最后学习的单元
      learnUnit: null,
      ///今日时长
      todayMinute:0,
      weekMinute:0,
      weekAvgMinute:0,
      listDate:[]
    }
  },
  mounted: function () {
    this.loadUserInfo()
    this.loadData()
  },
  methods: {
    ///加载数据
    loadData: function () {
      var that = this
      httpClient.invoke("SummaryAPI.GetUserHomeData", {}, function (res) {
        console.log("输出结果", res)
        if (res.error) {
          that.$message.error(res.error)
          return
        }
        that.learnUnit = res.learnUnit
        that.todayMinute = res.learnTime.todayMinute
        that.weekMinute = res.learnTime.weekTotalMinute
        that.weekAvgMinute = res.learnTime.weekAvgMinute
        that.listDate = res.learnTime.listDate
      })
    },
    ///加载用户信息
    loadUserInfo: function () {
      var userInfo = localUser.getLocalUser()
      console.log("localUser:", userInfo)
      this.nickName = userInfo.nickName
    },
    ///继续学习
    continueLearn: function () {
      var that = this
      const learnType = "order"
      var req = {
        bookId: this.learnUnit.bookId,
        unitId: this.learnUnit.unitId,
        learnType: learnType
      }
      //this.showLoading = true
      httpClient.invoke("LearnAPI.GetLearnIndex", req, function (res) {
        //console.log("返回结果", res)
        //that.showLoading = false
        if (res.error) {
          that.$message.error(res.error.message)
          return
        }
        if (res.listId.length == 0) {
          that.$message({ message: "没有可学习的数据" });
          return
        }
        var learnModel = {
          learnInfo: res,
          learnType: learnType,
          bookInfo: {
            bookId: that.learnUnit.bookId,
            bookName: that.learnUnit.bookName,
          },
          unitInfo: {
            unitId: that.learnUnit.unitId,
            unitName: that.learnUnit.unitName
          }
        }
        localCache.setObject("learnModel", learnModel)
        that.$router.push("/spell-word-tools")
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lbprog {
  color: var(--ek-text-color2);
}

.lblatelyw {
  color: var(--ek-text-color1);
  display: flex;
  align-items: center;
}

.splitd {
  margin-left: 5px;
  margin-right: 5px;
}

.laters {
  margin-top: 20px;
}

.bnt-learn {
  display: inline-flex;
  background: var(--ek-color-primary);
  color: white;
  margin-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
  height: 40px;
  align-items: center;
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;
}

.dvwel {
  border-bottom: 1px solid var(--ek-split-lineColor);
  padding-bottom: 20px;
}

.lbunit {
  font-size: 14px;
  font-weight: normal;
  margin-left: 5px;
  color: var(--ek-text-color2);
}

.inrect {
  padding-left: 30px;
  padding-top: 20px;
  padding-right: 30px;
}

.wtitle {
  color: var(--ek-text-color1);
}

.lbwsub {
  color: var(--ek-text-color2);
  margin-top: 10px;
}


.card-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 15px;
  margin-top: 30px;
}

.card-item {
  background: var(--ek-card-color1);
  padding-left: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  border-right: 1px solid var(--ek-split-lineColor);
}

.card-item .icon {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: rgba(37, 99, 235, 0.12);
  color: var(--primary);
  font-size: 1.1rem;
}

.card-item-title {
  font-size: 14px;
  color: var(--ek-text-color2);
}

.card-item-num {
  font-size: 24px;
  font-weight: bold;
  color: var(--ek-text-color1);
  margin-top: 20px;
}
</style>
